import React, { useState, useEffect } from "react";
import axios from 'axios';
import { adresPro, findMieszkanieId } from '../../../functions/ulice';
import { useSelector, useDispatch } from 'react-redux';
import { zl } from "../../../functions/utilities";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import DialogYesNo from "../../DialogYesNo.js";
import { fetchStawkiJednorazoweInd } from "../../../Redux/Actions";

const WspolnotyStawkiJednorazoweGrupyLista = props => {

    const { mieszkancy, lokale, ulice, wybranyMieszkaniec, stawkiJednorazoweInd, __WYBIERZ_MIESZKANCA__, udzialyKontaAkt } = props;

    const dispatch = useDispatch();
    
    const grupy = useSelector( state => state?.grupy?.data);
    
    const [open, setOpen] = useState(false);
    const [trashId, setTrashId] = useState(0);
    const [stawkiLista, setStawkiLista] = useState(undefined)

    useEffect( () => {
        if (wybranyMieszkaniec === __WYBIERZ_MIESZKANCA__) {
            setStawkiLista(stawkiJednorazoweInd)
        }
            
        else {
            setStawkiLista( stawkiJednorazoweInd?.filter( s => s?.id_user == wybranyMieszkaniec) )
        }
            
    },[wybranyMieszkaniec, stawkiJednorazoweInd])

    const handleClick = id => {
        setTrashId(id)
        setOpen(true);  
    }

    async function usunStawke(id) {
        try {
          const response = await axios.post('/api/wspolnoty_stawki_jednorazowe_ind/usun', { id: id });
          if (response.data.success === true)  {
            dispatch(fetchStawkiJednorazoweInd()); 
          }

          console.log('Response from backend:', response.data);
        } catch (error) {
          console.error('Error sending ID to backend:', error);
        }
    }
    
    const lista = stawkiLista?.map( (stawka, i) => {

        const mieszkaniec = mieszkancy?.find( m => m?.id_user == stawka?.id_user);
        const udzialKontaAkt = udzialyKontaAkt?.find( u => u?.id_user == stawka?.id_user && u?.grupa_numer == stawka?.grupa_numer )
        const grupy_m = grupy?.filter( g => g?.id_user == stawka?.id_user && g.grupa_numer == stawka?.grupa_numer)
        const mieszkanieId = findMieszkanieId(udzialKontaAkt, grupy_m, lokale);
        const mieszkanie = adresPro(mieszkanieId, lokale, ulice)

        return (
            <li key={i}>
                <div>
                    {`${mieszkaniec?.imie_nazwisko} (${mieszkaniec?.id_user})`}
                </div>
                <div className="central">
                    {stawka?.grupa_numer}
                </div>
                <div>
                    {mieszkanie}
                </div>
                <div>
                    {stawka?.msc}
                </div>
                <div>
                    {stawka?.opis}
                </div>
                <div style={{textAlign: "center"}}> 
                    {zl(stawka?.kwota)}
                </div>
                <div className="central">
                    <FontAwesomeIcon 
                        icon={faTrash} 
                        className="pointer" 
                        style={{"color": "red"}} 
                        onClick={()=>handleClick(stawka.id)}
                    /> 
                </div>
            </li>
        )
    })


    return (
        <div className="stawkiJednorazoweGrupyLista ">
            <DialogYesNo 
                open={open}
                setOpen={setOpen}
                message={`Czy na pewno chcesz usunąć tę stawkę?`}
                f={usunStawke}
                id={trashId}
            />
            <h3>
                Lista stawek jednorazowych indywidualnych
            </h3>
            <ul className="lista ramka-inset-shadow">
                <li key={0}>
                    <div>
                        Mieszkaniec
                    </div>
                    <div className="central">
                        Numer grupy
                    </div>
                    <div>
                        Lokal
                    </div>
                    <div>
                        Miesiąc
                    </div>
                    <div>
                        Opis
                    </div>
                    <div style={{textAlign: "center"}}>
                        Kwota
                    </div>
                    <div className="central">
                        Usuń
                    </div>
                </li>
                { lista }
            </ul>
        </div>
    )
}

export default WspolnotyStawkiJednorazoweGrupyLista;
